import clsx from 'clsx'
import {isEmpty, size, truncate} from 'lodash'
import React from 'react'
import {useIntl} from 'react-intl'
import {convertCurrency, KTSVG, toAbsoluteUrl} from '../../../../_gori/helpers'
import {InputTextFormik} from '../../../../_gori/partials/widgets'
import {OrdersConfig, OrderType} from '../core/_const'

type Props = {
  disabled?: any
  formik: any
  handleAddNewItem?: any
  handleDeleteItem?: any
  data?: any
}

const ItemPackages: React.FC<Props> = ({
  formik,
  data,
  disabled,
  handleAddNewItem,
  handleDeleteItem,
}) => {
  const intl = useIntl()
  const storeType = data?.store_type || OrderType.SHIPBAE

  return (
    <div>
      <div className='d-flex justify-content-between'>
        <span className='fw-bolder fs-5'>{intl.formatMessage({id: 'ITEMS'})}</span>
        {!disabled && (
          <div
            className={clsx(
              'btn btn-advanced-tertiary px-1 py-0 d-flex fs-inherit align-items-center fw-bolder cursor-pointer',
              {
                'cursor-no-drop': disabled,
              }
            )}
            onClick={() => !disabled && handleAddNewItem('order_items')}
          >
            <span className='fs-2 me-1'>+</span>
            {intl.formatMessage({id: 'ADD_ITEM'})}
          </div>
        )}
      </div>
      {formik?.values?.order_items &&
        Object.entries(formik.values.order_items).map(([keyItem, valueItem]: any, index) => {
          return (
            <React.Fragment key={keyItem}>
              <div
                className='bg-light rounded-2 mt-4 d-flex flex-column gap-4 shadow-xs'
                key={index}
              >
                <div
                  className='d-flex
              justify-content-between
              align-items-center fs-5 fw-bolder ps-5 bg-gray-300 rounded-2 rounded-bottom-0 h-50px'
                >
                  {intl.formatMessage({id: 'ITEM'})} {index + 1}
                  <div
                    className={clsx('text-hover-danger cursor-pointer', {
                      'd-none':
                        storeType !== OrderType.SHIPBAE || size(formik.values.order_items) <= 1,
                    })}
                    onClick={() => !disabled && handleDeleteItem('order_items', keyItem)}
                  >
                    <KTSVG path='/media/gori/orders/empty.svg' small={false} />
                  </div>
                </div>
                <div className='d-flex flex-fill flex-wrap p-5 pt-0'>
                  {storeType === OrderType.SHIPBAE ? (
                    Object.entries(OrdersConfig.ITEMS).map(([key, value], index) => {
                      return (
                        <div
                          className={clsx(
                            {'col-md-3': key !== 'TITLE' && key !== 'SKU'},
                            {'col-md-12': key === 'TITLE'},
                            {'col-md-6': key === 'SKU'}
                          )}
                          key={index}
                        >
                          <div className={clsx('mb-2 mx-2')}>
                            <InputTextFormik
                              {...(OrdersConfig.ITEMS[key].type === 'number'
                                ? {min: 0, max: 1000000}
                                : '')}
                              type={OrdersConfig.ITEMS[key].type}
                              labelClassName='col-form-label text-nowrap text-muted'
                              label={intl.formatMessage({id: value.label})}
                              formik={formik}
                              name={`order_items.${keyItem}.${value.value}`}
                              isInteger={value.value === OrdersConfig.ITEMS.QUANTITY.value}
                              required={value.value === OrdersConfig.ITEMS.TITLE.value}
                              disabled={disabled}
                            />
                          </div>
                        </div>
                      )
                    })
                  ) : (
                    <>
                      <div className='d-flex'>
                        <div
                          className={clsx('me-5', {
                            'd-none': storeType !== OrderType.SHOPIFY,
                          })}
                        >
                          <img
                            src={
                              !isEmpty(valueItem?.image)
                                ? valueItem?.image
                                : toAbsoluteUrl('/media/gori/no-image.svg')
                            }
                            alt={valueItem.title}
                            className='w-80px h-80px'
                          />
                        </div>
                        <div className='fw-bold'>
                          <p>
                            {intl.formatMessage({id: 'ITEM_NAME'})}: {valueItem.title}
                          </p>
                          <div className='d-flex mb-4'>
                            <div className='pe-8 mw-200px text-truncate'>
                              {intl.formatMessage({id: 'SKU'})}:{' '}
                              {truncate(valueItem.sku, {length: 15, omission: '...'})}
                            </div>
                            <div className='border-item'></div>
                            <div className='pe-8 ps-8'>
                              {intl.formatMessage({id: 'QUANTITY'})}: {valueItem.quantity}
                            </div>
                            <div className='border-item'></div>
                            <div className='ps-8'>
                              {intl.formatMessage({id: 'ITEM_VALUE'})}:{' '}
                              {convertCurrency(valueItem.unit_price)}
                            </div>
                          </div>
                          <div className='d-flex'>
                            {Object.entries(valueItem?.variant ?? []).map(([key, option]: any) => {
                              return (
                                <>
                                  <div
                                    className={clsx('', {
                                      'border-item': key > 0,
                                    })}
                                  ></div>
                                  <div
                                    className={clsx('pe-8', {
                                      'ps-8': key > 0,
                                    })}
                                    key={key}
                                  >
                                    {option.name}: {option.value}
                                  </div>
                                </>
                              )
                            })}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </React.Fragment>
          )
        })}
    </div>
  )
}

export {ItemPackages}
